/**
 * @description
 * Helper functions
 */

let isMobile = false;
const bodyScrollLock = require('body-scroll-lock');
 
export default function initHelpers() {
    // Go to Top button
    $(document).on('click', '.dd-l-footer__gotop-btn', (e) => {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });


    // Open video modal
    $(document).on('click', '.dd-l-section--video__btn-play', (e) => {
        e.preventDefault();

        $('.dd-m-modal--video').css('display', 'flex').hide().fadeIn('fast');
    });

    // Detect if current device is mobile
    function mobileDetection() {
        if ($(window).width() <= 752 && !isMobile) {
            $('body').addClass('is-mobile');
            isMobile = true;
        } else if ($(window).width() > 752 && isMobile) {
            $('body').removeClass('is-mobile');
            bodyScrollLock.clearAllBodyScrollLocks();
            $('body').removeClass('dd-b-hidden');
            isMobile = false;
        }
    }

    mobileDetection();

    $(window).resize(()=> {
        mobileDetection();
    });
}


// WEBPACK FOOTER //
// ./resources/site/js/components/helpers.js